export const AUTH_ONBOARDING_MESSAGES = [
  "Retail Trader? Meet Infinite Situational Awareness.",
  "Welcome to the trenches. We've been expecting you.",
  "Agentic Event Tracking for Futures Analysts. The time is here.",
  "Welcome! If you're gonna piss like a puppy, stay on the porch.",
  "Bloomberg without the information you don't need to day trade.",
  "Bloomberg, but in the future, for retail traders.",
  "Infinite Situational Awareness.",
  "Monitor The Situation from the new pit for Retail Traders.",
  "No crying in the casino. Monitor the situation within.",
  "Let's get started. Sign in Below.",
];

type AuthOnboardingState = {
  isReturning: boolean;
  message: string | null;
};

const messageIndexKey = "fintheon:auth:onboarding-message-index";
const firstSeenKey = "fintheon:auth:first-seen-at";
const activeFirstSessionKey = "fintheon:auth:first-session-active";

export function readAuthOnboardingState(): AuthOnboardingState {
  if (typeof window === "undefined") {
    return { isReturning: false, message: AUTH_ONBOARDING_MESSAGES[0] };
  }

  try {
    const { localStorage, sessionStorage } = window;
    const activeFirstSession =
      sessionStorage.getItem(activeFirstSessionKey) === "1";
    const hasSeenAuth = localStorage.getItem(firstSeenKey) !== null;
    const hasAuthSession = storageKeys(localStorage).some(isAuthStorageKey);

    if (hasAuthSession || (hasSeenAuth && !activeFirstSession)) {
      return { isReturning: true, message: null };
    }

    const storedIndex = Number(localStorage.getItem(messageIndexKey));
    const messageIndex =
      Number.isInteger(storedIndex) &&
      storedIndex >= 0 &&
      storedIndex < AUTH_ONBOARDING_MESSAGES.length
        ? storedIndex
        : Math.floor(Math.random() * AUTH_ONBOARDING_MESSAGES.length);

    localStorage.setItem(messageIndexKey, String(messageIndex));
    localStorage.setItem(
      firstSeenKey,
      localStorage.getItem(firstSeenKey) ?? new Date().toISOString(),
    );
    sessionStorage.setItem(activeFirstSessionKey, "1");

    return {
      isReturning: false,
      message: AUTH_ONBOARDING_MESSAGES[messageIndex],
    };
  } catch {
    return { isReturning: false, message: AUTH_ONBOARDING_MESSAGES[0] };
  }
}

function storageKeys(storage: Storage) {
  return Array.from({ length: storage.length }, (_, index) => {
    return storage.key(index) ?? "";
  });
}

function isAuthStorageKey(key: string) {
  return (
    key.startsWith("sb-") ||
    key.includes("supabase.auth.token") ||
    key.includes("fintheon:auth:session")
  );
}
